

<h1 matDialogTitle>{{title}}</h1>
<div matDialogContent>{{message}}</div>
<div matDialogActions fxLayoutAlign="space-around center">

  <button matDialogClose mat-button  (click)="dialogRef.close(false) ">Cancel</button>
  <button matDialogClose mat-button  (click)="dialogRef.close(true)">Confirm</button>
</div>